import moment from "moment";

import {
  ADD_FAVOURITE,
  FETCH_ALL_CONTACT_SUCCESS,
  FILTER_CONTACT,
  GET_ALL_CONTACT,
  GET_UNSELECTED_ALL_CONTACT,
  HANDLE_REQUEST_CLOSE,
  HIDE_CONTACT_LOADER,
  ON_ADD_CONTACT,
  ON_ALL_CONTACT_SELECT,
  ON_CONTACT_CLOSE,
  ON_CONTACT_SELECT,
  ON_DELETE_CONTACT,
  ON_DELETE_SELECTED_CONTACT,
  ON_FILTER_OPTION_SELECT,
  ON_SAVE_CONTACT,
  ON_TOGGLE_DRAWER,
  SHOW_MESSAGE,
  UPDATE_SEARCH_USER,
  SET_EMPLOYEE_WORKING_HOURS,
  SET_EMPLOYEE_WORKING_HOURS_DATE,
  SET_EMPLOYEE_WORKING_HOURS_FROM,
  SET_EMPLOYEE_WORKING_HOURS_TO,
  SET_EMPLOYEE_WORKING_HOURS_COMMENT,
  CHANGE_WORKING_HOURS_SUBMIT,
  CHANGE_ADMIN_EMPLOYEE_DISPLAY,
  WORKING_HOURS_UPDATE,
  SET_ALL_SERVICES_BY_BUSINESS,
  SET_IMAGE_FILE,
  SET_SERVICE_TABLE_SERVICES,
  SUBMIT_ALL_VALUES_EMPLOYEE_RESPONSE,
  FILL_ADMIN_EMPLOYEE_SELECTED_DETAILS,
  SUBMIT_EDIT_EMPLOYEE_DETAILS_RESPONSE,
  CHANGE_EDIT_EMPLOYEE_STATE,
  CHANGE_ADD_EMPLOYEE_STATE,
  CLEAR_FORM_DATA,
  SELECTED_EMPLOYEE_DELETE_RESPONSE,
  CHANGE_ADD_WORKING_HOURS_STATE,
  CHANGE_EDIT_WORKING_HOURS_STATE,
  DELETE_SELECTED_WORKING_HOURS_RESPONSE,
  EDIT_WORKING_HOURS_RESPONSE,
  EMPLOYEE_FAIL_RESPONSE,
  EMPLOYEE_ON_HIDE_LOADER,
  EMPLOYEE_ON_SHOW_LOADER,
  EMPLOYEE_DELETE_WORKING_HOURS_MODAL_TOGGLE,
  EMPLOYEE_DONT_DELETE_WORKING_HOURS,
  EMPLOYEE_ADD_WORKING_HOURS_FORCEFULLY_RESPONSE,
  EMPLOYEE_DELETE_WORKING_HOURS_FORCEFULLY_RESPONSE,
  EMPLOYEE_OUT_OF_BUSINESS_HOURS_ADD,
  EMPLOYEE_EDIT_WORKING_HOURS_FORCEFULLY_RESPONSE,
  BULK_EMPLOYEE_CLOSE_WORKING_HOURS,
  BULK_EMPLOYEE_ADD_WORKING_HOURS_FORCEFULLY_RESPONSE,
  EMPLOYEE_WORKING_HOURS_SHOW_LOADER,
  EMPLOYEE_WORKING_HOURS_HIDE_LOADER,
  EMPLOYEE_WORKING_HOURS_CLEAR_TABLE,
  EMPLOYEE_WORKING_HOURS_NEW_REQUEST_CLOSE,
  EMPLOYEE_BUSINESS_CLOSURE_CANCEL,
  EMPLOYEE_BUSINESS_CLOSURE_DAY,
  EMPLOYEE_BUSINESS_CLOSURE_FROM,
  EMPLOYEE_BUSINESS_CLOSURE_TO,
  EMPLOYEE_BUSINESS_CLOSURE_DAY_ERROR_ADD,
  EMPLOYEE_BUSINESS_CLOSURE_DAY_ERROR_REMOVE,
  EMPLOYEE_BUSINESS_CLOSURE_SUBMIT_RESPONSE,
  EMPLOYEE_BUSINESS_CLOSURE_OPERATIONS_SET,
  EMPLOYEE_BUSINESS_WORKING_HOURS_DELETE_FORCEFULLY_RESPONSE,
  EMPLOYEE_BUSINESS_WORKING_HOURS_EDIT_FORCEFULLY_RESPONSE,
  EMPLOYEE_BUSINESS_WORKING_HOURS_ADD_FORCEFULLY_RESPONSE,
  EMPLOYEE_BUSINESS_WORKING_HOURS_SUBMIT_RESPONSE,
  EMPLOYEE_BUSINESS_CLOSURE_SCHEDULE_SET,
  BUSINESS_EXCEPTION_BASED_AVAILIABLITY,
  EMPLOYEE_BUSINESS_WORKING_HOURS_HAVE_APPOINTMENT,
  EMPLOYEE_BUSINESS_WORKING_HOURS_DELETE_APPOINTMENT,
  EMPLOYEE_BUSINESS_WORKING_HOURS_DELETE_SUBMIT_RESPONSE,
  EMPLOYEE_BUSINESS_WORKING_HOURS_EDIT_SUBMIT_RESPONSE,
  EMPLOYEE_BUSINESS_HANDLE_REQUEST_CLOSE,
  GET_EMPLOYEE_PLAN_SUCCESS,
  REMOVE_EMPLOYEE_IMAGE,
} from "../constants/ActionTypes";

const INIT_STATE = {
  alertMessage: "",
  showMessage: false,
  errorMessage: false,
  loader: true,
  employeeLoader: false,
  workingHoursLoader: false,
  noContentFoundMessage: "No Employee found",
  selectedSectionId: 1,
  drawerState: false,
  user: {
    name: "Robert Johnson",
    email: "robert.johnson@example.com",
    avatar: "http://via.placeholder.com/150x150",
  },
  searchUser: "",
  filterOption: "All contacts",
  allContact: [],
  contactList: [],
  selectedContact: null,
  selectedContacts: 0,
  addContactState: false,
  displayComponent: 1,
  employeeWorkingHoursId: "",
  employeeWorkingHours: [],
  employeeWorkingHoursFrom: '9:00',
  employeeWorkingHoursTo: '21:00',
  employeeWorkingHoursDate: null,
  employeeWorkingHoursComment: "",
  workingHoursSubmitButton: true,
  servicesByBusiness: [],
  imageFile: null,
  imageid:"",
  serviceTableServices: [],
  noOfEmployee:10,
  employeeDetails: {
    firstname: "",
    lastname: "",
    email: "",
    phonenumber: "",
    title: "",
    enabled: true,
    _id: "",
    primarydetails: {},
    services_offered: [],
  },
  addEmployeeState: false,
  editEmployeeState: false,
  editWorkingHoursState: false,
  addWorkingHoursState: true,
  employeeModal: false,
  appointmentWorkingHours: [],
  businessCloseWorkingHours: [],
  bulkEmployeeData: [],
  newWorkingHours: false,
  operations: {},
  defaultOperations: {},
  schedule: [],
  toggle: false,
  errors: {},
  exceptionBasedAviliablity: false,
  exceptionEmployeeState: false,
};

export default (state = INIT_STATE, { type, payload }) => {
  switch (type) {
    case FETCH_ALL_CONTACT_SUCCESS: {
      return {
        ...state,
        loader: false,
        allContact: payload,
        contactList: payload,
      };
    }
    case SHOW_MESSAGE: {
      return {
        ...state,
        alertMessage: payload,
        showMessage: true,
        loader: false,
      };
    }
    case ON_CONTACT_SELECT: {
      payload.selected = !payload.selected;
      let selectedContacts = 0;
      const contactList = state.contactList.map(contact => {
        if (contact.selected) {
          selectedContacts++;
        }

        if (contact.id === payload.id) {
          if (contact.selected) {
            selectedContacts++;
          }
          return payload;
        }
        return contact;
      });

      return {
        ...state,
        INIT_STATE,
        selectedContacts,
        contactList,
      };
    }

    case ON_SAVE_CONTACT: {
      let isNew = true;
      const contactList = state.allContact.map(contact => {
        if (contact.id === payload.id) {
          isNew = false;
          return payload;
        }
        return contact;
      });
      if (isNew) {
        contactList.push(payload);
      }
      return {
        ...state,
        alertMessage: isNew ? "Contact Added Successfully" : "Contact Updated Successfully",
        showMessage: true,
        contactList,
        allContact: contactList,
      };
    }
    case ON_DELETE_CONTACT: {
      return {
        ...state,
        alertMessage: "Contact Deleted Successfully",
        showMessage: true,
        allContact: state.allContact.filter(contact => contact.id !== payload.id),
        contactList: state.allContact.filter(contact => contact.id !== payload.id),
      };
    }
    case ON_DELETE_SELECTED_CONTACT: {
      const contacts = state.allContact.filter(contact => !contact.selected);
      return {
        ...state,
        alertMessage: "Contact Deleted Successfully",
        showMessage: true,
        allContact: contacts,
        contactList: contacts,
        selectedContacts: 0,
      };
    }

    case GET_ALL_CONTACT: {
      const contactList = state.allContact.map(contact =>
        contact
          ? {
              ...contact,
              selected: true,
            }
          : contact
      );
      return {
        ...state,
        selectedContacts: contactList.length,
        allContact: contactList,
        contactList,
      };
    }
    case GET_UNSELECTED_ALL_CONTACT: {
      const contactList = state.allContact.map(contact =>
        contact
          ? {
              ...contact,
              selected: false,
            }
          : contact
      );
      return {
        ...state,
        selectedContacts: 0,
        allContact: contactList,
        contactList,
      };
    }
    case ON_ALL_CONTACT_SELECT: {
      const selectAll = state.selectedContacts < state.contactList.length;
      let selectedContacts = 0;
      let contactList = [];
      if (selectAll) {
        contactList = state.allContact.map(contact =>
          contact
            ? {
                ...contact,
                selected: true,
              }
            : contact
        );
        selectedContacts = contactList.length;
      } else {
        contactList = state.allContact.map(contact =>
          contact
            ? {
                ...contact,
                selected: true,
              }
            : contact
        );
        selectedContacts = 0;
      }
      return {
        ...state,
        selectedContacts,
        allContact: contactList,
        contactList,
      };
    }
    case UPDATE_SEARCH_USER: {
      const { allContact } = state;
      const contactList = allContact.filter(item => {
        const { firstname, lastname, primarydetails } = item;
        const name = `${firstname} ${lastname}`;
        const { email, phonenumber } = primarydetails;
        return (
          name.toLowerCase().indexOf(payload.trim().toLowerCase()) > -1 ||
          email.toLowerCase().indexOf(payload.trim().toLowerCase()) > -1 ||
          phonenumber.indexOf(payload.trim()) > -1
        );
      });

      return { ...state, searchUser: payload, contactList };
    }
    case HANDLE_REQUEST_CLOSE: {
      return {
        ...state,
        showMessage: false,
        errorMessage: false,
        employeeLoader: false,
        alertMessage: "",
      };
    }
    case ON_TOGGLE_DRAWER: {
      return { ...state, drawerState: !state.drawerState };
    }
    case HIDE_CONTACT_LOADER: {
      return { ...state, loader: false };
    }
    case SET_EMPLOYEE_WORKING_HOURS: {
      let searchTerm = "";

      if (state.exceptionBasedAviliablity) {
        searchTerm = "unavailable";
      } else {
        searchTerm = "available";
      }
      return {
        ...state,
        employeeWorkingHours: payload.filter(item => item.entryType === searchTerm),
      };
    }

    case SET_EMPLOYEE_WORKING_HOURS_DATE:
    // if(empl)
    if(typeof payload == 'object' && payload != null) {
      if(payload.from != undefined) {
        if(typeof payload.from == 'function') {
          return { ...state, employeeWorkingHoursDate: payload };
        }
        return { ...state, employeeWorkingHoursDate: payload.date, employeeWorkingHoursFrom: payload.from, employeeWorkingHoursTo: payload.to };
      } else {
          return { ...state, employeeWorkingHoursDate: payload, employeeWorkingHoursFrom: '9:00', employeeWorkingHoursTo: '21:00' };
        }
      }
			return { ...state, employeeWorkingHoursDate: payload };

    case SET_EMPLOYEE_WORKING_HOURS_FROM:
      if(payload == null || payload == '')
        payload = '9:00';
      return { ...state, employeeWorkingHoursFrom: payload };

    case SET_EMPLOYEE_WORKING_HOURS_TO:
      if(payload == null || payload == '')
        payload = '21:00';
      return { ...state, employeeWorkingHoursTo: payload };

    case SET_EMPLOYEE_WORKING_HOURS_COMMENT:
      return { ...state, employeeWorkingHoursComment: payload };

    case CHANGE_WORKING_HOURS_SUBMIT:
      return { ...state, workingHoursSubmitButton: payload };

    case CHANGE_ADMIN_EMPLOYEE_DISPLAY:
      return {
        ...state,
        displayComponent: payload,
      };
    case WORKING_HOURS_UPDATE: {
      const { from, to, employeeId: employee, entryType, isNew, _id } = payload;
      let { employeeWorkingHours } = state;
      if (typeof employee === "object") {
        employeeWorkingHours = employeeWorkingHours.filter(
          item => !moment(from).isSame(moment(item.from), "date")
        );
      }

      return {
        ...state,
        employeeWorkingHours: [
          { from, to, employee, entryType, isNew, _id },
          ...employeeWorkingHours,
        ],
        employeeWorkingHoursDate: null,
        employeeWorkingHoursFrom: '9:00',
        employeeWorkingHoursTo: '21:00',
        alertMessage: "vibo.notification.workingHours.add",
        showMessage: true,
        employeeLoader: false,
        newWorkingHours: true,
      };
    }

    case SET_ALL_SERVICES_BY_BUSINESS:
      return { ...state, servicesByBusiness: payload };

    case SET_IMAGE_FILE:
        let imageid = "";
        if(state.imageFile != null && state.imageFile._id != undefined) {
          imageid= state.imageFile._id;
        }
        if(state.imageid != "") {
          imageid= state.imageid;
        }
      return { ...state, imageFile: payload, imageid };

    case SET_SERVICE_TABLE_SERVICES:
      return { ...state, serviceTableServices: payload };

    case SUBMIT_ALL_VALUES_EMPLOYEE_RESPONSE: {
      let searchTerm = "";

      if (state.exceptionBasedAviliablity) {
        searchTerm = "unavailable";
      } else {
        searchTerm = "available";
      }

      return {
        ...state,
        displayComponent: state.exceptionBasedAviliablity ? 4 : 3,
        employeeWorkingHoursId: payload._id,
        alertMessage: "vibo.notification.employee.add",
        showMessage: true,
        addEmployeeState: false,
        editWorkingHoursState: false,
        editEmployeeState: false,
        addWorkingHoursState: true,
        employeeLoader: false,
        allContact: [...state.allContact, payload],
        contactList: [...state.contactList, payload],
        operations: payload.operations,
        schedule: payload.schedule.filter(item => item.entryType === searchTerm),
        employeeDetails: {
          ...state.employeeDetails,
          firstname: payload.firstname,
          lastname: payload.lastname,
        },
      };
    }

    case FILL_ADMIN_EMPLOYEE_SELECTED_DETAILS: {
      const {
        firstname,
        lastname,
        title,
        photo,
        enabled,
        _id,
        primarydetails,
        services_offered,
        operations,
        schedule,
      } = payload;

      const { email, phonenumber } = primarydetails;

      return {
        ...state,
        employeeDetails: {
          ...state.employeeDetails,
          firstname,
          lastname,
          title,
          enabled,
          _id,
          phonenumber,
          email,
          primarydetails,
          services_offered,
        },
        editEmployeeState: true,
        displayComponent: state.exceptionBasedAviliablity ? 4 : 3,
        imageFile: photo,
        operations,
        schedule,
        defaultOperations: operations,
        employeeWorkingHoursId: _id,
      };
    }
    case GET_EMPLOYEE_PLAN_SUCCESS :
      return{
        ...state,
        noOfEmployee:payload

      }
    case CHANGE_EDIT_EMPLOYEE_STATE:
      return {
        ...state,
        editEmployeeState: payload,
        editWorkingHoursState: false,
        addEmployeeState: !payload,
        addWorkingHoursState: true,
      };

    case CHANGE_ADD_EMPLOYEE_STATE:
      return {
        ...state,
        addEmployeeState: payload,
        addWorkingHoursState: true,
        editWorkingHoursState: false,
        editEmployeeState: !payload,
        // employeeDetails: {...INIT_STATE.employeeDetails}
      };

    case SUBMIT_EDIT_EMPLOYEE_DETAILS_RESPONSE: {
      let { allContact } = state;
      allContact = allContact.filter(item => item._id !== payload._id);
      let searchTerm = "";

      if (state.exceptionBasedAviliablity) {
        searchTerm = "unavailable";
      } else {
        searchTerm = "available";
      }

      return {
        ...state,
        displayComponent: 1,
        alertMessage: "vibo.notification.employee.update",
        showMessage: true,
        editEmployeeState: false,
        employeeWorkingHoursId: payload._id,
        editWorkingHoursState: false,
        addEmployeeState: false,
        addWorkingHoursState: true,
        employeeLoader: false,
        allContact: [...allContact, payload],
        contactList: [...allContact, payload],
        operations: payload.operations,
        schedule: payload.schedule.filter(item => item.entryType === searchTerm),
        employeeDetails: {
          ...state.employeeDetails,
          firstname: payload.firstname,
          lastname: payload.lastname,
        },
      };
    }

    case CLEAR_FORM_DATA:
      return {
        ...state,
        employeeDetails: {
          ...state.employeeDetails,
          firstname: "",
          lastname: "",
          email: "",
          phonenumber: "",
          title: "",
          enabled: true,
          _id: "",
          primarydetails: {},
          services_offered: [],
        },
        serviceTableServices: [],
        imageFile: null,
      };

    case SELECTED_EMPLOYEE_DELETE_RESPONSE: {
      let { allContact } = state;
      allContact = allContact.filter(item => !item.selected);

      return {
        ...state,
        alertMessage: "vibo.notification.employee.delete",
        showMessage: true,
        selectedContacts: 0,
        allContact,
        contactList: allContact,
      };
    }

    case CHANGE_ADD_WORKING_HOURS_STATE:
      return { ...state, addWorkingHoursState: payload, editWorkingHoursState: !payload, employeeWorkingHours: [] };

    case CHANGE_EDIT_WORKING_HOURS_STATE:
      return { ...state, editWorkingHoursState: payload, addWorkingHoursState: !payload };

    case DELETE_SELECTED_WORKING_HOURS_RESPONSE: {
      let { employeeWorkingHours } = state;

      payload.forEach(id => {
        employeeWorkingHours = employeeWorkingHours.filter(item => item._id !== id);
      });
      return {
        ...state,
        alertMessage: "vibo.notification.workingHours.delete",
        showMessage: true,
        employeeWorkingHours,
        addWorkingHoursState: true,
        editWorkingHoursState: false,
      };
    }

    case EDIT_WORKING_HOURS_RESPONSE: {
      const { from, to, employeeId: employee, entryType, _id, isNew } = payload;
      const remainingWorkingHours = state.employeeWorkingHours.filter(item => item._id !== _id);

      return {
        ...state,
        employeeWorkingHours: [
          { from, to, employee, entryType, _id, isNew },
          ...remainingWorkingHours,
        ],
        employeeWorkingHoursDate: null,
        employeeWorkingHoursFrom: '9:00',
        employeeWorkingHoursTo: '21:00',
        alertMessage: "vibo.notification.workingHours.update",
        showMessage: true,
        addWorkingHoursState: true,
        editWorkingHoursState: false,
        employeeLoader: false,
        newWorkingHours: true,
      };
    }

    case EMPLOYEE_FAIL_RESPONSE:
      return { ...state, errorMessage: true, alertMessage: payload, employeeLoader: false };

    case EMPLOYEE_ON_HIDE_LOADER:
      return { ...state, employeeLoader: false };

    case EMPLOYEE_ON_SHOW_LOADER: {
      return { ...state, employeeLoader: true };
    }

    case EMPLOYEE_DELETE_WORKING_HOURS_MODAL_TOGGLE:
      return { ...state, employeeModal: !state.employeeModal };

    case EMPLOYEE_DONT_DELETE_WORKING_HOURS:
      return {
        ...state,
        appointmentWorkingHours: payload,
        employeeModal: true,
        addWorkingHoursState: false,
        editWorkingHoursState: false,
      };
    case EMPLOYEE_OUT_OF_BUSINESS_HOURS_ADD:
      return { ...state, businessCloseWorkingHours: payload, employeeModal: true };
    case EMPLOYEE_ADD_WORKING_HOURS_FORCEFULLY_RESPONSE: {
      const { from, to, employeeId: employee, entryType, isNew, _id } = payload;

      return {
        ...state,
        employeeModal: false,
        appointmentWorkingHours: [],
        alertMessage: "vibo.notification.workingHours.add",
        showMessage: true,
        employeeLoader: false,
        employeeWorkingHours: [
          { from, to, employee, entryType, isNew, _id },
          ...state.employeeWorkingHours,
        ],
        employeeWorkingHoursDate: null,
        employeeWorkingHoursFrom: '9:00',
        employeeWorkingHoursTo: '21:00',
        addWorkingHoursState: true,
        editWorkingHoursState: false,
        workingHoursLoader: false,
        newWorkingHours: true,
      };
    }

    case EMPLOYEE_DELETE_WORKING_HOURS_FORCEFULLY_RESPONSE: {
      let { employeeWorkingHours } = state;

      payload.forEach(id => {
        employeeWorkingHours = employeeWorkingHours.filter(item => item._id !== id);
      });

      return {
        ...state,
        alertMessage: "vibo.notification.workingHours.delete",
        showMessage: true,
        businessCloseWorkingHours: [],
        employeeModal: false,
        addWorkingHoursState: true,
        editWorkingHoursState: false,
        employeeWorkingHours,
        workingHoursLoader: false,
      };
    }

    case EMPLOYEE_EDIT_WORKING_HOURS_FORCEFULLY_RESPONSE: {
      const { from, to, employeeId: employee, entryType, _id, isNew } = payload;
      const remainingWorkingHours = state.employeeWorkingHours.filter(item => item._id !== _id);

      return {
        ...state,
        employeeWorkingHours: [
          { from, to, employee, entryType, _id, isNew },
          ...remainingWorkingHours,
        ],
        employeeWorkingHoursDate: null,
        employeeWorkingHoursFrom: '9:00',
        employeeWorkingHoursTo: '21:00',
        workingHoursLoader: false,
        alertMessage: "vibo.notification.workingHours.update",
        showMessage: true,
        addWorkingHoursState: true,
        editWorkingHoursState: false,
        employeeLoader: false,
        newWorkingHours: true,
        employeeModal: false,
        appointmentWorkingHours: [],
      };
    }

    case BULK_EMPLOYEE_CLOSE_WORKING_HOURS:
      return { ...state, bulkEmployeeData: payload, employeeModal: true };
    case BULK_EMPLOYEE_ADD_WORKING_HOURS_FORCEFULLY_RESPONSE: {
      const { from, to, employee, entryType, isNew, _id } = payload;

      let { employeeWorkingHours } = state;

      if (typeof employee === "object") {
        employeeWorkingHours = employeeWorkingHours.filter(item => {
          if (moment(from).isSame(moment(item.from), "dates")) {
            return false;
          }
          return true;
        });
      }

      return {
        ...state,
        employeeModal: false,
        bulkEmployeeData: [],
        employeeLoader: false,
        workingHoursLoader: false,
        employeeWorkingHours: [{ from, to, employee, entryType, isNew }, ...employeeWorkingHours],
        employeeWorkingHoursDate: null,
        employeeWorkingHoursFrom: '9:00',
        employeeWorkingHoursTo: '21:00',
        newWorkingHours: true,
      };
    }

    case EMPLOYEE_WORKING_HOURS_SHOW_LOADER:
      return { ...state, workingHoursLoader: true };

    case EMPLOYEE_WORKING_HOURS_HIDE_LOADER:
      return { ...state, workingHoursLoader: false };

    case EMPLOYEE_WORKING_HOURS_CLEAR_TABLE:
      return { ...state, employeeWorkingHours: [] };

    case EMPLOYEE_WORKING_HOURS_NEW_REQUEST_CLOSE: {
      let { employeeWorkingHours } = state;
      employeeWorkingHours = employeeWorkingHours.map(item => {
        if (item.isNew) {
          delete item.isNew;
        }
        return item;
      });

      return { ...state, newWorkingHours: false, employeeWorkingHours };
    }

    case EMPLOYEE_BUSINESS_CLOSURE_DAY: {
      const keys = Object.keys(state.operations);
      const ans = keys.includes(payload.day);
      const { operations, errors } = state;

      if (ans) {
        delete operations[payload.day];
        delete errors[payload.day];
        return {
          ...state,
          operations,
          toggle: !state.toggle,
          errors,
        };
      }
      let data = payload.businessOperations[`${payload.day}`];
      return {
        ...state,
        operations: {
          ...state.operations,
          [payload.day]: {
            from: moment(`${moment().format("YYYY-MM-DD")} ${moment(data.from).format('HH:mm')}`),
            to: moment(`${moment().format("YYYY-MM-DD")} ${moment(data.to).format('HH:mm')}`),
            // from: moment(`${moment().format("YYYY-MM-DD")} 9:00`),
            // to: moment(`${moment().format("YYYY-MM-DD")} 9:30`),
          },
        },
        toggle: !state.toggle,
      };
    }

    case EMPLOYEE_BUSINESS_CLOSURE_FROM: {
      return {
        ...state,
        operations: {
          ...state.operations,
          [payload.day]: {
            ...state.operations[payload.day],
            from: payload.value,
          },
        },
      };
    }

    case EMPLOYEE_BUSINESS_CLOSURE_TO: {
      return {
        ...state,
        operations: {
          ...state.operations,
          [payload.day]: {
            ...state.operations[payload.day],
            to: payload.value,
          },
        },
      };
    }

    case EMPLOYEE_BUSINESS_CLOSURE_SUBMIT_RESPONSE:
    let editIndex = null;
      let { contactList } = state;
      contactList.forEach((item, index) => {
        if (item._id === payload._id) {
          editIndex = index;
        }
      });

      contactList = [
        ...contactList.slice(0, editIndex),
        payload,
        ...contactList.slice(editIndex + 1, contactList.length)
      ];

      // let contact = {...state.contactList.filter(function (el) {
      //   return el._id == payload.id;
      // })};
      
      // contact[0].operations = {...payload.operations};

      return {
        ...state,
        alertMessage: "vibo.notification.employee.operations",
        showMessage: true,
        workingHoursLoader: false,
        operations: { ...payload.operations },
        defaultOperations: { ...payload.operations },
        contactList,
        employeeWorkingHoursId: payload.id,

      };

    case EMPLOYEE_BUSINESS_CLOSURE_DAY_ERROR_ADD:
      return {
        ...state,
        errors: { ...state.errors, [payload.day]: payload.error },
      };

    case EMPLOYEE_BUSINESS_CLOSURE_DAY_ERROR_REMOVE: {
      const { errors } = state;
      delete errors[payload.day];
      return { ...state, errors };
    }

    case EMPLOYEE_BUSINESS_CLOSURE_CANCEL:
      return {
        ...state,
        operations: { ...state.defaultOperations },
        errors: {}
      };

    case EMPLOYEE_BUSINESS_CLOSURE_OPERATIONS_SET:
      return {
        ...state,
        operations: payload,
      };

    case BUSINESS_EXCEPTION_BASED_AVAILIABLITY:
      return {
        ...state,
        exceptionBasedAviliablity: payload,
        exceptionEmployeeState: true,
      };

    case EMPLOYEE_BUSINESS_WORKING_HOURS_SUBMIT_RESPONSE:
      return {
        ...state,
        schedule: [payload, ...state.schedule],
        employeeLoader: false,
        alertMessage: "vibo.notification.unavailableHours.add",
        showMessage: true,
        newWorkingHours: true,
      };

    case EMPLOYEE_BUSINESS_WORKING_HOURS_EDIT_SUBMIT_RESPONSE: {
      let { schedule } = state;
      schedule = schedule.filter(item => item._id !== payload._id);

      return {
        ...state,
        schedule: [payload, ...schedule],
        employeeLoader: false,
        alertMessage: "vibo.notification.unavailableHours.update",
        showMessage: true,
        newWorkingHours: true,
      };
    }

    case EMPLOYEE_BUSINESS_WORKING_HOURS_DELETE_SUBMIT_RESPONSE: {
      let { schedule } = state;

      payload.forEach(id => {
        schedule = schedule.filter(item => item._id !== id);
      });

      return {
        ...state,
        schedule,
        alertMessage: "vibo.notification.unavailableHours.delete",
        showMessage: true,
        employeeLoader: false,
      };
    }

    case EMPLOYEE_BUSINESS_HANDLE_REQUEST_CLOSE: {
      let { schedule } = state;
      schedule = schedule.map(item => {
        if (item.isNew) {
          delete item.isNew;
        }
        return item;
      });

      return { ...state, newWorkingHours: false, schedule };
    }

    case EMPLOYEE_BUSINESS_WORKING_HOURS_HAVE_APPOINTMENT: {
      return {
        ...state,
        businessCloseWorkingHours: payload,
        employeeModal: true,
      };
    }

    case EMPLOYEE_BUSINESS_WORKING_HOURS_DELETE_APPOINTMENT:
      return {
        ...state,
        appointmentWorkingHours: payload,
        employeeModal: true,
        addWorkingHoursState: false,
        editWorkingHoursState: false,
      };

    case EMPLOYEE_BUSINESS_WORKING_HOURS_ADD_FORCEFULLY_RESPONSE: {
      return {
        ...state,
        businessCloseWorkingHours: {},
        employeeModal: false,
        alertMessage: "vibo.notification.unavailableHours.add",
        workingHoursLoader: false,
        showMessage: true,
        addWorkingHoursState: true,
        editWorkingHoursState: false,
        employeeLoader: false,
        newWorkingHours: true,
        schedule: [payload, ...state.schedule],
      };
    }

    case EMPLOYEE_BUSINESS_WORKING_HOURS_EDIT_FORCEFULLY_RESPONSE: {
      const schedule = state.schedule.filter(item => item._id !== payload._id);

      return {
        ...state,
        schedule: [payload, ...schedule],
        businessCloseWorkingHours: {},
        employeeModal: false,
        alertMessage: "vibo.notification.unavailableHours.update",
        workingHoursLoader: false,
        showMessage: true,
        addWorkingHoursState: true,
        editWorkingHoursState: false,
        employeeLoader: false,
        newWorkingHours: true,
      };
    }
    case REMOVE_EMPLOYEE_IMAGE : {
      return{...state,imageFile:null,displayComponent:1}
    }
    case EMPLOYEE_BUSINESS_WORKING_HOURS_DELETE_FORCEFULLY_RESPONSE: {
      let { schedule } = state;

      payload.forEach(id => {
        schedule = schedule.filter(item => item._id !== id);
      });

      return {
        ...state,
        schedule,
        appointmentWorkingHours: [],
        employeeModal: false,
        alertMessage: "vibo.notification.unavailableHours.delete",
        workingHoursLoader: false,
        showMessage: true,
        addWorkingHoursState: true,
        editWorkingHoursState: false,
        employeeLoader: false,
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/EmployeeReducer.js